type ExperienceRenderKeyState = {
  hasVariants: boolean;
  status: 'loading' | 'success' | 'error';
  baselineId: string;
  experienceId?: string | null;
  lastResolvedExperienceId: string;
  variantId: string;
  isVariantHidden: boolean;
};

export const buildNinetailedExperienceRenderKey = ({
  hasVariants,
  status,
  baselineId,
  experienceId,
  lastResolvedExperienceId,
  variantId,
  isVariantHidden
}: ExperienceRenderKeyState): string => {
  if (!hasVariants) {
    return `baseline-${baselineId}`;
  }

  if (status === 'loading') {
    const resolvedExperienceId = experienceId ?? lastResolvedExperienceId;

    return `loading-${resolvedExperienceId}-${baselineId}`;
  }

  if (isVariantHidden) {
    return `hidden-${experienceId ?? lastResolvedExperienceId}-${baselineId}`;
  }

  return `${experienceId || 'baseline'}-${variantId}`;
};
